import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { ACCOUNT_MANAGER_SCOPE, ACCOUNT_TYPE, ACCOUNT_MANAGER_GROUP_ID } from '../../constants/miscellaneous';

@Injectable({
  providedIn: 'root',
})
export class AccountManagerService {

  accountManager: Promise<{ addAccount, getPassword, getUserAccount, initWithKey, removeAccount }>;

  constructor(private platform: Platform) {
    this.accountManager = this.platform.ready().then(() => {
      if ('its' in window && 'accountManager' in window['its']) {
        const { accountManager } = window['its'] as any;
        accountManager.initWithKey('racionalapp');
        return accountManager;
      } else {
        const accountManager = {
          uid: '',
          [ACCOUNT_MANAGER_SCOPE]: '',
          // tslint:disable-next-line: no-use-before-declare
          getUserAccount: function () { readSuccess(arguments, this); },
          // tslint:disable-next-line: no-use-before-declare
          getPassword: function () { readSuccess(arguments, this); },
          // tslint:disable-next-line: no-use-before-declare
          addAccount: function () { saveSuccess(arguments, arguments[0], arguments[1]); },
          // tslint:disable-next-line: no-use-before-declare
          removeAccount: function () { saveSuccess(arguments, '', ''); },
        };
        const readSuccess = (args: IArguments, value) => args[args.length - 2](value);
        const saveSuccess = function (args: IArguments, user: string, password: string) {
          this.uid = user;
          this[ACCOUNT_MANAGER_SCOPE] = password;
          args[args.length - 2]();
        }.bind(accountManager);
        return accountManager;
      }
    });
  }

  public async getUsername(): Promise<string> {
    return new Promise<string>(async (res) => {
      const accountManager = await this.accountManager;
      accountManager.getUserAccount(ACCOUNT_TYPE, ACCOUNT_MANAGER_GROUP_ID, ACCOUNT_MANAGER_SCOPE,
        ({ uid }) => res(uid),
        () => res(''),
      );
    });
  }

  public getPassword() {
    return new Promise<string>(async (res) => {
      const accountManager = await this.accountManager;
      accountManager.getPassword(ACCOUNT_TYPE, ACCOUNT_MANAGER_GROUP_ID, ACCOUNT_MANAGER_SCOPE,
        response => res(response[ACCOUNT_MANAGER_SCOPE]),
        () => res(''),
      );
    });
  }

  public addAccount(username: string, password: string) {
    const userData = { scope: ACCOUNT_MANAGER_SCOPE, uid: username, univ_num: username };
    return new Promise<void>(async (res, rej) => {
      const accountManager = await this.accountManager;
      accountManager.addAccount(username, password, ACCOUNT_TYPE, ACCOUNT_MANAGER_GROUP_ID, userData,
        () => res(),
        async error => {
          rej(error);
          console.log(error);
        },
      );
    });
  }

  public removeAccount() {
    return new Promise(async (res) => {
      const accountManager = await this.accountManager;
      accountManager.removeAccount(ACCOUNT_TYPE, ACCOUNT_MANAGER_SCOPE,
        response => res(response),
        async error => {
          res(null);
          console.log(error);
        },
      );
    });
  }

}
